import { Button, Table, TableColumns, TableColumnWidth, TableData, TablePreferences, Select, Card, TextBox, IconWarningAlt, SelectOption, Modal, IconTrash, ListItem, OptionInterface, IconPlus, Tabs, ContextualMenu, IconSave, ButtonGroup } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import '../../assets/css/views/brands.css';
import appointmentService from "../../services/agendaApi/appointment.service";
import { ISubretailDto } from "../../models/dto/agendaApi/ISubretailDto";
import { IPointOfSaleByListDto } from "../../models/dto/agendaApi/IPointOfSaleDto";
import salesService from "../../services/agendaApi/sales.service";
import { IBrandByPos, IBrandBySubretail, IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import brandsService from "../../services/surveyApi/brands.service";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import dataListService from "../../services/generalApi/dataList.service";
import { ICountryDto } from "../../models/dto/generalApi/ICountryDto";



export default function Brands() {
    const [t] = useTranslation("global");
    type SelectValue = number | string | boolean; //CHECK
    const languageId: any = useSelector((state: RootState) => state.languageId);

    const [posData, setPosData] = useState<SelectOption[]>([]);
    const [posDataFiltered, setPosDataFiltered] = useState<SelectOption[]>([]);
    const [subretailData, setSubretailData] = useState<SelectOption[]>([]);
    const [subretailDataFiltered, setSubretailDataFiltered] = useState<SelectOption[]>([]);
    const [countriesData, setCountriesData] = useState<SelectOption[]>([]);
    const [countriesDataFiltered, setCountriesDataFiltered] = useState<SelectOption[]>([]);
    const [brands, setBrands] = useState<IBrandDto[]>([]);
    const [brandsTable, setBrandsTable] = useState<IBrandDto[]>([]);



    const [posSelected, setPosSelected] = useState<SelectValue[]>([]);
    const [subretailSelected, setSubretailSelected] = useState<SelectValue[]>([]);
    const [countrySelected, setCountrySelected] = useState<SelectValue[]>([]);


    const [search, setSearch] = useState<string>('');

    const [loadingTableData, setLoadingTableData] = useState<boolean>(false);
    const [showModalBrands, setShowModalBrands] = useState<boolean>(false);

    const [disabledFunctions, setDisableFunctions] = useState<boolean>(true);
    const [disabledSelectPos, setDisabledSelectPos] = useState<boolean>(true);
    const [disabledSelectSubretail, setDisabledSelectSubretail] = useState<boolean>(true);
    const [disabledSelectCountry, setDisabledSelectCountry] = useState<boolean>(true);



    const [error, setError] = useState<boolean>(true);



    const [tableData, setTableData] = useState<TableData[]>([]);
    const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
    const [brandsTab, setBrandsTab] = useState<number>(0);

    const [brandIdSelected, setBrandIdSelected] = useState<number>(NaN);

    const [showModalConfirmCreation, setShowModalConfirmCreation] = useState<boolean>(false);
    const [showModalConfirmDeletion, setShowModalConfirmDeletion] = useState<boolean>(false);



    useEffect(() => {
        getCountryData();
        getBrandsData();
    }, [])

    useEffect(() => {
        setError(false);
        if (brandsTab === 0 && countrySelected.length > 0 && subretailSelected.length > 0) {
            resetDataChange().then(() => {
                getPosData(Number(subretailSelected));
            });
        }
    }, [subretailSelected])

    useEffect(() => {
        setError(false);
        if (countrySelected.length > 0) {
            getSubretailsData();
        }
    }, [countrySelected])

    useEffect(() => {
        resetData();
    }, [brandsTab])


    const resetData = () => {
        setTableData([]);
        setTableDataFiltered([]);
        setSubretailSelected([]);
        setPosSelected([]);
        setCountrySelected([]);
        setPosData([]);
        setSubretailData([]);
        setDisableFunctions(true);
        setLoadingTableData(false);
        setBrandsTable([]);
        setSearch('');
        setDisabledSelectPos(true);
        setDisabledSelectSubretail(true);
    }

    const resetDataForSubretail = () => {
        setTableData([]);
        setTableDataFiltered([]);
        setSubretailSelected([]);
        setPosSelected([]);
        setPosData([]);
        setDisableFunctions(true);
        setLoadingTableData(false);
        setBrandsTable([]);
        setSearch('');
        setDisabledSelectPos(true);
        setSubretailSelected([]);
    }

    const resetDataChange = () => {
        setTableData([]);
        setTableDataFiltered([]);
        setBrandsTable([]);
        setSearch('');
        return new Promise(resolve => setTimeout(resolve, 0));
    };

    useEffect(() => {
        if (brandsTab === 0) {
            if (subretailSelected.length > 0 && posSelected.length > 0) {
                setLoadingTableData(true);
                getBrandsDataByPos(String(posSelected));
                if (brands.length > 0) {
                    setDisableFunctions(false);
                }
            }
        } else {
            if (subretailSelected.length > 0) {
                setLoadingTableData(true);
                getBrandsDataBySubretail(Number(subretailSelected));
                if (brands.length > 0) {
                    setDisableFunctions(false);
                }
            }
        }

    }, [subretailSelected, posSelected])


    const getSubretailsData = () => {
        try {
            dataListService.getSubretailListByCountry(Number(countrySelected))
                .then(r => {
                    if(r.length > 0){
                        fillDataSubretail(r);

                    }else{
                        setError(true);
                    }
                })
        } catch (error) {
            console.error(error);
        }

    }

    const fillDataSubretail = (data: ISubretailDto[]) => {
        const subretailData: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const subretail: ISubretailDto = data[i];
            let selectedSubretailData: SelectOption;
            selectedSubretailData = {
                value: subretail.fieldID,
                label: subretail.fieldValue,
            };
            subretailData.push(selectedSubretailData);
        }
        setSubretailData(subretailData);
        setSubretailDataFiltered(subretailData);
        setDisabledSelectSubretail(false);
    };

    const getCountryData = () => {
        try {
            dataListService.getCountryListBySubregion()
                .then(r => {
                    fillDataCountries(r)
                })
        } catch (error) {
            console.error(error);
        }
    }

    const fillDataCountries = (data: ICountryDto[]) => {
        const countriesData: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const country: ICountryDto = data[i];
            let selectCountryData: SelectOption;
            selectCountryData = {
                value: country.contryId,
                label: country.countryName,
            };
            countriesData.push(selectCountryData);

        }
        setCountriesData(countriesData);
        setCountriesDataFiltered(countriesData);
        setDisabledSelectCountry(false);
    };


    const getPosData = (subretailId: number) => {
        try {
            appointmentService.getPosListBySubretailList(String(subretailId))
                .then(r => {
                    if(r.length > 0){
                        fillDataPointOfSale(r)
                    }else {
                        setError(true);
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }

    const fillDataPointOfSale = (data: IPointOfSaleByListDto[]) => {
        const pointOfsaleData: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const pointOfsale: IPointOfSaleByListDto = data[i];
            let selectePointOfSaleData: SelectOption;
            if (pointOfsale.fieldID) {
                selectePointOfSaleData = {
                    value: pointOfsale.fieldID,
                    label: pointOfsale.fieldValue,
                };
                pointOfsaleData.push(selectePointOfSaleData);
            }
        }
        setPosData(pointOfsaleData);
        setPosDataFiltered(pointOfsaleData);
        setDisabledSelectPos(false);
    };

    const getBrandsData = () => {
        try {
            brandsService.getBrands()
                .then(r => {
                    setBrands(r);
                }).catch((e) => console.error())
        } catch (error) {
            console.error(error);

        }
    }

    const getBrandsDataByPos = (posSelected: string) => {
        try {
            brandsService.getBrandsByPos(posSelected, languageId.value)
                .then(r => {    
                    if (posSelected.length > 0) {
                        setBrandsTable(r);
                        fillDataBrandsPos(r);
                    }
                }).catch((e) => console.error())
        } catch (error) {
            console.error(error);
        }
    }

    const fillDataBrandsPos = (data: IBrandDto[]) => {
        const pagedData: TableData[] = [];
        for (let i = 0; i < data.length; i++) {
            const brand: IBrandDto = data[i];
            let tableData: TableData = {};
            tableData = {
                'brandID': brand.brandID,
                'brandName': brand.brandName,
                'categories': brand.categories,
                'delete': <Button onClick={() => { handleChangeDeleteBrand(brand.brandID) }} className="brandsButtonDelete" leadingIcon={<IconTrash />}></Button>,
            }
            pagedData.push(tableData);
        }
        setTableData(pagedData);
        setTableDataFiltered(pagedData);
        setLoadingTableData(false);

    }

    const getBrandsDataBySubretail = (subretailId: number) => {
        try {
            brandsService.getBrandsBySubretail(subretailId, languageId.value)
                .then(r => {
                    setBrandsTable(r);
                    fillDataBrandsSubretail(r);
                }).catch((e) => console.error())
        } catch (error) {
            console.error(error);
        }
    }

    const fillDataBrandsSubretail = (data: IBrandDto[]) => {
        const pagedData: TableData[] = [];
        for (let i = 0; i < data.length; i++) {
            const brand: IBrandDto = data[i];
            let tableData: TableData = {};
            tableData = {
                'brandID': brand.brandID,
                'brandName': brand.brandName,
                'categories': brand.categories,
                'delete': <Button onClick={() => { handleChangeDeleteBrand(brand.brandID) }} className="brandsButtonDelete" leadingIcon={<IconTrash />}></Button>,
            }
            pagedData.push(tableData);
        }
        setTableData(pagedData);
        setTableDataFiltered(pagedData);
        setLoadingTableData(false);

    }


    const columns: TableColumns[] = [
        {
            id: 'brandName',
            label: t("header.brands"),
        },
        {
            id: 'categories',
            label: t("header.categories"),
        },
        {
            id: 'delete',
            label: t("header.delete"),
        },
    ];

    const columnsWidth: TableColumnWidth[] = [
        {
            columnId: 'brandName',
            width: "45%"
        },
        {
            columnId: 'categories',
            width: "35%"
        },
        {
            columnId: 'delete',
            width: "20%"
        },

    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }


    const handleChangeSearch = (value: string) => {
        setSearch(value);
        const filterArray = tableData.filter((element) => {
            if (element.brandName.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setTableDataFiltered(filterArray)
    }

    const handleChangeSearchSubretail = (value: string) => {
        const filterArray = subretailData.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setSubretailDataFiltered(filterArray)
    }

    const handleChangeSearchCountry = (value: string) => {
        const filterArray = countriesData.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setCountriesDataFiltered(filterArray)
    }

    const handleChangeSearchPos = (value: string) => {
        const filterArray = posData.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setPosDataFiltered(filterArray)
    }


    const handleChangeAddBrand = (brandId: number) => {
        setBrandIdSelected(brandId);
        setShowModalConfirmCreation(true);

    }

    const handleChangeDeleteBrand = (brandId: number) => {
        setBrandIdSelected(brandId);
        setShowModalConfirmDeletion(true);
    }

    const confirmCreation = () => {
        if (brandsTab === 0) {
            let brandByPosIn: IBrandByPos = {
                brandID: brandIdSelected,
                posCode: String(posSelected)
            }
            brandsService.postBrandByPos(brandByPosIn)
                .then(r => {
                    setLoadingTableData(true);
                    setSearch('');
                    getBrandsDataByPos(String(posSelected));
                    setShowModalConfirmCreation(false);
                    setShowModalBrands(false);
                })
        } else {
            let brandBySubretailIn: IBrandBySubretail = {
                brandID: brandIdSelected,
                subretailID: Number(subretailSelected)
            }
            brandsService.postBrandBySubretail(brandBySubretailIn)
                .then(r => {
                    setLoadingTableData(true);
                    setSearch('');
                    getBrandsDataBySubretail(Number(subretailSelected));
                    setShowModalConfirmCreation(false);
                    setShowModalBrands(false);
                })

        }

    }
    const confirmDeletion = () => {
        if (brandsTab === 0) {
            brandsService.deleteBrandByPos(brandIdSelected, String(posSelected))
                .then(r => {
                    setLoadingTableData(true);
                    setSearch('');
                    getBrandsDataByPos(String(posSelected));
                    setShowModalConfirmDeletion(false);
                })
        } else {
            brandsService.deleteBrandBySubretail(brandIdSelected, Number(subretailSelected))
                .then(r => {
                    setLoadingTableData(true);
                    setSearch('');
                    getBrandsDataBySubretail(Number(subretailSelected));
                    setShowModalConfirmDeletion(false);

                })

        }
    }
    const cancelCreation = () => {
        setBrandIdSelected(NaN);
        setShowModalConfirmCreation(false);
    }
    const cancelDeletion = () => {
        setBrandIdSelected(NaN);
        setShowModalConfirmDeletion(false);
    }

    const handleChangeOnClearPos = () => {
        setPosSelected([]);
        setTableData([]);
        setTableDataFiltered([]);
        setDisableFunctions(true);
        setLoadingTableData(false);
        setBrandsTable([]);
        setSearch('');
    }

    const handleChangeOnClearSubretail = () => {
        resetDataForSubretail();
    }


    const handleChangeOnClearCountry = () => {
        resetData();
    }

    const handleChangeSubretail = (e: any) => {
        resetDataForSubretail();
        setSubretailSelected([e.value]);
    }

    const handleChangeCountry = (e: any) => {
        resetData();
        setCountrySelected([e.value]);
    }




    return (
        <div className="brands">
            <h4 className="brandsTItle">{t("header.brands")}</h4>

            <Tabs
                className="brandsTabs"
                controlId="brandsTabs"
                mode="extended"
                onChangeTab={setBrandsTab}
                selectedTabId={brandsTab}
                tabs={[
                    {
                        id: 0, label: t("header.pos"), content:
                            <>
                                <div className="brandsDivTop">
                                    <div className="brandsDivTopSelects">
                                        <Select
                                            className="brandsSelect"
                                            label={t("header.country")}
                                            disabled={disabledSelectCountry}
                                            options={countriesDataFiltered}
                                            value={countrySelected}
                                            onChange={handleChangeCountry}
                                            onClear={handleChangeOnClearCountry}
                                            placement="bottom-start"
                                            showSearch
                                            onSearch={handleChangeSearchCountry}
                                            error={error}
                                        />
                                        <Select
                                            className="brandsSelect"
                                            label={t("header.subRetail")}
                                            disabled={disabledSelectSubretail}
                                            options={subretailDataFiltered}
                                            value={subretailSelected}
                                            onChange={handleChangeSubretail}
                                            onClear={handleChangeOnClearSubretail}
                                            placement="bottom-start"
                                            showSearch
                                            onSearch={handleChangeSearchSubretail}
                                            error={error}
                                        />
                                        <Select
                                            className="brandsSelect"
                                            label={t("header.pos")}
                                            disabled={disabledSelectPos}
                                            options={posDataFiltered}
                                            value={posSelected}
                                            onChange={e => setPosSelected([e.value])}
                                            onClear={handleChangeOnClearPos}
                                            placement="bottom-start"
                                            showSearch
                                            onSearch={handleChangeSearchPos}
                                            error={error}
                                        />
                                    </div>

                                    <Button disabled={disabledFunctions} onClick={() => setShowModalBrands(true)} className="brandsButtonAddBrand"  >{t("header.addBrand")}</Button>

                                </div>

                                <Card
                                    appearance="outlined"
                                    className="pricesDiv"
                                    content={<>

                                        <TextBox
                                            className="searchPricesTextbox"
                                            id="searchPricesTextbox"
                                            label={t("header.search")}
                                            type="search"
                                            onChange={handleChangeSearch}
                                            value={search}
                                            disabled={disabledFunctions}
                                        />

                                        <Table
                                            className="priceProductTable"
                                            behavior={{
                                                type: 'singlePage',
                                            }}
                                            columnResize
                                            preferences={tablePreferences}
                                            loading={loadingTableData}
                                            columns={columns}
                                            data={tableDataFiltered}
                                            loadingDataLength={10}
                                            customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                        />
                                    </>}
                                />
                            </>

                    },
                    {
                        id: 1, label: t("header.subRetail"), content:

                            <>
                                <div className="brandsDivTop">
                                    <div className="brandsDivTopSelects">
                                        <Select
                                            className="brandsSelect"
                                            label={t("header.country")}
                                            disabled={disabledSelectCountry}
                                            options={countriesDataFiltered}
                                            value={countrySelected}
                                            onChange={handleChangeCountry}
                                            onClear={handleChangeOnClearCountry}
                                            placement="bottom-start"
                                            showSearch
                                            onSearch={handleChangeSearchCountry}
                                            error={error}
                                        />
                                        <Select
                                            className="brandsSelect"
                                            label={t("header.subRetail")}
                                            disabled={disabledSelectSubretail}
                                            options={subretailDataFiltered}
                                            value={subretailSelected}
                                            onChange={e => setSubretailSelected([e.value])}
                                            onClear={handleChangeOnClearSubretail}
                                            placement="bottom-start"
                                            showSearch
                                            onSearch={handleChangeSearchSubretail}
                                            error={error}
                                        />
                                    </div>

                                    <Button disabled={disabledFunctions} onClick={() => setShowModalBrands(true)} className="brandsButtonAddBrand"  >{t("header.addBrand")}</Button>

                                </div>

                                <Card
                                    appearance="outlined"
                                    className="pricesDiv"
                                    content={<>

                                        <TextBox
                                            className="searchPricesTextbox"
                                            id="searchPricesTextbox"
                                            label={t("header.search")}
                                            type="search"
                                            onChange={handleChangeSearch}
                                            value={search}
                                            disabled={disabledFunctions}

                                        />

                                        <Table
                                            className="priceProductTable"
                                            behavior={{
                                                type: 'singlePage',
                                            }}
                                            columnResize
                                            preferences={tablePreferences}
                                            loading={loadingTableData}
                                            columns={columns}
                                            data={tableDataFiltered}
                                            loadingDataLength={10}
                                            customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                        />
                                    </>}
                                />
                            </>

                    },

                ]}
                type="online"
            />



            <div style={{ position: 'relative' }}>
                <Modal
                    align="center"
                    id="modalBrandsList"
                    show={showModalBrands}
                    closeButton
                    onClose={() => setShowModalBrands(false)}
                    title={t("header.brands")}
                >
                    <div className="modalBrandsList">
                        {brands.length > 0 && brands.filter(item => !brandsTable.some(brand => item.brandID === brand.brandID)).map((brand, index) => {
                            return (<ListItem
                                key={'brand' + index}
                                leadingArea={brand.brandName}
                                trailingArea={<Button onClick={() => handleChangeAddBrand(brand.brandID)} leadingIcon={<IconPlus />}
                                />} />)
                        })}
                    </div>
                </Modal>
            </div>




            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalBrandsConfirmCreation"
                    align="center"
                    id="modalBrandsConfirmCreation"
                    show={showModalConfirmCreation}
                    footer={(
                        <ButtonGroup className="modalBrandsConfirmCreationButtonGroup">
                            <Button onClick={() => confirmCreation()}>{t("header.confirm")}</Button>
                            <Button onClick={() => cancelCreation()} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("header.addBrand")}
                >
                    <IconSave size={120} />
                    <br />
                    {brandsTab === 0 ?
                        <b>{t("header.messageAddBrandByPos")}</b>
                        :
                        <b>{t("header.messageAddBrandBySubretail")}</b>
                    }
                </Modal>
            </div>




            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalBrandsConfirmDeletion"
                    align="center"
                    id="modalBrandsConfirmDeletion"
                    show={showModalConfirmDeletion}
                    footer={(
                        <ButtonGroup className="modalBrandsConfirmDeletionButtonGroup">
                            <Button onClick={() => confirmDeletion()}>{t("header.confirm")}</Button>
                            <Button onClick={() => cancelDeletion()} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("header.deleteBrand")}
                >
                    <IconTrash size={120} />
                    <br />
                    {brandsTab === 0 ?
                        <b>{t("header.messageDeleteBrandByPos")}</b>
                        :
                        <b>{t("header.messageDeleteBrandBySubretail")}</b>
                    }
                </Modal>
            </div>




        </div>
    );
}